import React from "react";
import { NewUserModal } from "../components/NewUserModal";
import { routes } from "utilities/routing/generatedRoutes";

interface Props {
  isOpen: boolean;
  onClose: () => void;
}

export const NewUserForExternalModal = (props: Props) => {
  return <NewUserModal
    isOpen={props.isOpen}
    onClose={props.onClose}
    title={RESX.UserType.NewExternalUser}
    environment="external"
    submitFunc={formState => window.CoreApi.UserForExternalAdmin.Invite({
      email: formState.email,
      firstName: formState.firstName,
      freeFieldProfileId: formState.freeFieldProfile.freeFieldProfileId,
      language: formState.language.value,
      lastName: formState.lastName,
      userName: formState.username,
    })}
    redirectUrl={(userId: number) => routes.externalUser_Detail(userId).absolute} />
}